module.exports = __webpack_public_path__ + "img/pc-add-doc2.b6fdb089.svg";